import { graphqlClient } from "../../../client";
import mutationDocument from "./logClientInformationMutation.graphql";
import type {
  Mutations,
  MutationsLogClientInformationArgs,
  InputLogClientInformationType,
} from "@/core/api/graphql/types";

export const logClientInformation = async (payload: InputLogClientInformationType): Promise<boolean> => {
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "logClientInformation">>,
    MutationsLogClientInformationArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: payload,
    },
  });

  return data?.logClientInformation ?? false;
};
